import React from 'react'
import { compose } from 'redux'
import { reduxForm } from 'redux-form'
import { Text } from '@cred/react-text'
import RadioGroup from 'components/radio-group'
import MoneyInput from 'components/money-input'
import { required } from '@cred/shared/validations'
import PropTypes from 'prop-types'
import { minMaxLoanAmount } from 'student-loan/rate-table/validations'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'
import Footer from 'multi-vertical/rate-table/components/filter-modal/footer'
import styles from './styles.scss'

const getStyleNames = (isMulti) => (
    {
      filters: isMulti ? styles['multi-filters'] : styles.filters,
      roleLabel: isMulti ? styles['multi-role-label'] : styles.roleLabel,
      radio: isMulti ? styles['multi-radio'] : styles.radio,
      radioComp: isMulti ? styles['multi-radio-comp'] : styles.radioComp,
      loanAmount: isMulti ? styles['multi-loan-amount'] : styles.loanAmount,
    }
  ),
  FilterForm = ({ closeModal, update, reset, invalid, onAmountChange, onRoleChange, withFooter, multiVertical }) => {
    const cancel = () => {
        closeModal()
        // Setting timeout so the form doesn't reset as the modal is disappearing
        setTimeout(() => { reset() }, 500)
      },
      names = getStyleNames(multiVertical)

    return (
      <>
        <form className={[names.filters, 'pure-g'].join(' ')} method="POST" onSubmit={(e) => e.preventDefault()}>
          <div className="pure-u-1 pure-u-sm-11-24 pure-u-md-1-2">
            <div className="mr-md-8 mb-16">
              <div className={[names.roleLabel, 'mr-16', 'mb-8', 'mb-md-0'].join(' ')}>
                <Text type="display">I am a:</Text>
              </div>
              <div className={names.radio}>
                <RadioGroup
                  name="role"
                  className={names.radioComp}
                  options={[
                    { value: 'borrower', label: 'Student' },
                    { value: 'cosigner', label: 'Co-signer' },
                  ]}
                  branding={
                    { radioButtonContainer: 'btn-container', radioButtonLabel: 'btn-label' }
                  }
                  onChange={onRoleChange}
                  size="small"
                />
              </div>
            </div>
          </div>
          <div className="pure-u-1 pure-u-sm-11-24 pure-u-md-1-2">
            <div className={[names.loanAmount, 'ml-sm-8', 'mb-sm-8', 'mb-24'].join(' ')}>
              <MoneyInput
                onChange={onAmountChange}
                name="loanAmount"
                label="Loan Amount"
                placeholder="Loan amount"
                exposeValue
                validate={[required, minMaxLoanAmount]}
                icon={false}
              />
            </div>
          </div>
        </form>
        { withFooter && <Footer cancel={cancel} invalid={invalid} update={update} /> }
      </>
    )
  },

  noop = () => { }

FilterForm.propTypes = {
  closeModal: PropTypes.func,
  update: PropTypes.func,
  reset: PropTypes.func,
  invalid: PropTypes.bool,
  withFooter: PropTypes.bool,
  onAmountChange: PropTypes.func,
  onRoleChange: PropTypes.func,
  multiVertical: PropTypes.bool,
}

FilterForm.defaultProps = {
  closeModal: noop,
  update: noop,
  reset: noop,
  onAmountChange: noop,
  onRoleChange: noop,
  withFooter: false,
  multiVertical: false,
}

export { FilterForm as FilterFormNoHoc }


export default compose(
  withSnowplowContexts,
  reduxForm({
  // form: formName - components rendering FilterForm should include form in props
    enableReinitialize: true,
    keepDirtyOnReinitialize: false,
  }),
)(FilterForm)
